import { Badge, Divider, Flex, Text } from "@mantine/core";
import dayjs from "dayjs";
import { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { BackButton } from "src/components/shared/BackButton/BackButton";
import Section from "src/components/shared/EntriesGenerator/Section/Section/Section";
import Loader from "src/components/shared/Loader/Loader";
import { useGetApi } from "src/hooks";
import { type ISection } from "src/interfaces";
import { useDispatch } from "src/redux/hooks";
import { setUsers } from "src/redux/slices/entriesGeneratorSlice";
import { useShowContent } from "src/generator/hooks/useShowContent";
import { WorkspaceContainer } from "src/styled";
import { getWidgetSections } from "src/components/pages/Home/CustomDashboard/Widget.utils";
import { DateTimeDisp } from "src/components/shared/DateTime";
import { GeneratorV2 } from "src/generatorV2";

const EntryHistory = () => {
  const { shouldHideElement } = useShowContent();
  const { hid } = useParams();
  const dispatch = useDispatch();

  const entryHistoryMapper = useCallback(
    (data: any) => {
      dispatch(setUsers(data.data.users));

      return {
        lbEntry: data.data.entry?.data?.lbentry,
        sections:
          data.data.entry.data.weid || data.data.entry.data.sections
            ? getWidgetSections(data.data.entry.data.sections)
            : (data.data.entry.data.lbentry.sections as ISection[]),
        date: data.data.entry.timestamp,
        dateutc: data.data.entry.timestampUTC,
        lbname: data.data.lbname,
      };
    },
    [dispatch],
  );
  const { data, isLoading } = useGetApi({
    request: "view-hist-entry",
    body: { params: { hid } },
    mapper: entryHistoryMapper,
  });

  useEffect(() => {
    data?.sections?.length && console.log({ historySections: data?.sections });
  }, [data?.sections]);

  const isV2 = data?.lbEntry?.generator === "v2";

  return (
    <WorkspaceContainer>
      <Flex align="center" gap={25} mih={"58px"}>
        <BackButton />
        <Text maw={400} data-cy="lbname">
          {data?.lbname}
        </Text>
        <DateTimeDisp
          dir="row"
          color="blue"
          utc={data?.dateutc}
          lt={data?.date}
        />
        <Badge size="lg" variant="light" color="orange">
          History
        </Badge>
      </Flex>

      <Divider mb={32} />
      {isLoading ? (
        <Loader />
      ) : data ? (
        isV2 ? (
          <div
            style={{
              height: "calc(100vh - 104px - 58px - 32px - 1px - 45px)", // header - logbar - gap - divider - padding
            }}>
            <GeneratorV2
              logbookDef={data.lbEntry}
              entryInfo={{ entryDate: data.date }}
              options={{ readonly: true }}
            />
          </div>
        ) : (
          data.sections.map((s, i) => {
            if (shouldHideElement(s)) return null;
            return (
              <Section
                key={i}
                section={s}
                sIndex={i}
                historyRows={undefined}
                deletedRows={undefined}
              />
            );
          })
        )
      ) : (
        <></>
      )}
    </WorkspaceContainer>
  );
};

export default EntryHistory;
